import styled from 'styled-components';
import Link from '@mlb/react-patterns/v4/components/Link/link';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';

const { mlbWhite } = COLORS;

export const TapStoryContainer = styled.div`
    aspect-ratio: 16 / 9;
    width: 100%;
`;

export const TapStoryIFrame = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
`;

export const StoryOverlayWrapper = styled.div`
    position: relative;
    font-family: var(--gameday-primary-font);

    svg {
        position: absolute;
        z-index: 1;
        top: 1rem;
        left: 1rem;

        * {
            stroke: none; // was looking a lil chonky with stroke.
        }
    }
`;

export const TapStoryText = styled.div`
    padding: 1rem;
    font-size: 23px;
    display: flex;
    line-height: 20px;
    font-weight: bold;
    color: ${mlbWhite};
    align-items: flex-end;
`;

export const TapStoryInfo = styled.div`
    width: 100%;
    border-radius: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 100%;
    flex-grow: 0;
    background-image: var(--gameday-game-story-gradient);
    display: flex;
`;

export const MobileStoryLink = styled(Link)`
    height: 100%;
    width: 100%;
    display: block;
    z-index: 2;
    position: absolute;
    box-sizing: border-box;
    &:focus {
        border: 2px solid var(--gameday-link-color);
        outline: none;
    }
`;
